export default import.meta.ROLLDOWN_FILE_URL_eY4LJfPV5j04kkbdM$9juA